export var Name = 'delay-subscription-failed';
export var DelaySubscriptionFailedEvent = Name;